import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.27.4/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.27.4/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.27.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["animationId", "autoplay", "backgroundColor", "className", "createDotLottie", "data", "dotLottieRefCallback", "layout", "loop", "mode", "playOnHover", "renderConfig", "segment", "speed", "src", "style", "themeData", "themeId", "useFrameInterpolation", "workerId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { DotLottieWorker, DotLottie } from '@lottiefiles/dotlottie-web';
import { useState, useRef, useEffect, useCallback } from 'react';
import { jsx } from 'react/jsx-runtime';
var m = function m(_ref) {
  var o = _ref.animationId,
    E = _ref.autoplay,
    D = _ref.backgroundColor,
    W = _ref.className,
    S = _ref.createDotLottie,
    c = _ref.data,
    b = _ref.dotLottieRefCallback,
    n = _ref.layout,
    d = _ref.loop,
    g = _ref.mode,
    w = _ref.playOnHover,
    k = _ref.renderConfig,
    s = _ref.segment,
    y = _ref.speed,
    a = _ref.src,
    h = _ref.style,
    P = _ref.themeData,
    l = _ref.themeId,
    R = _ref.useFrameInterpolation,
    O = _ref.workerId,
    v = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    r = _useState2[0],
    C = _useState2[1],
    f = useRef(null),
    t = useRef(null),
    T = useRef(b),
    x = {
      speed: y,
      mode: g,
      loop: d,
      useFrameInterpolation: R,
      segment: s,
      backgroundColor: D,
      autoplay: E,
      themeId: l,
      workerId: O,
      src: a,
      data: c,
      layout: n,
      renderConfig: k
    },
    u = useRef(x);
  T.current = b, t.current = r, u.current = x, useEffect(function () {
    typeof T.current == "function" && r && T.current(r);
  }, [r]);
  var J = useCallback(function (i) {
    if (f.current = i, i) {
      var L = S(_objectSpread(_objectSpread({}, u.current), {}, {
        canvas: i
      }));
      C(L);
    } else r !== null && r !== void 0 && r.destroy(), C(null);
  }, []);
  return useEffect(function () {
    var _f$current, _f$current2;
    var i = function i(L) {
      var _t$current, _t$current2;
      w && (L.type === "mouseenter" && (_t$current = t.current) !== null && _t$current !== void 0 && _t$current.play(), L.type === "mouseleave" && ((_t$current2 = t.current) === null || _t$current2 === void 0 ? void 0 : _t$current2.pause()));
    };
    return (_f$current = f.current) !== null && _f$current !== void 0 && _f$current.addEventListener("mouseenter", i), (_f$current2 = f.current) !== null && _f$current2 !== void 0 && _f$current2.addEventListener("mouseleave", i), function () {
      var _f$current3, _f$current4;
      (_f$current3 = f.current) !== null && _f$current3 !== void 0 && _f$current3.removeEventListener("mouseenter", i), (_f$current4 = f.current) === null || _f$current4 === void 0 ? void 0 : _f$current4.removeEventListener("mouseleave", i);
    };
  }, [w]), useEffect(function () {
    return function () {
      r && (r.destroy(), C(null));
    };
  }, [r]), useEffect(function () {
    var _t$current3;
    (_t$current3 = t.current) === null || _t$current3 === void 0 || _t$current3.setSpeed(y !== null && y !== void 0 ? y : 1);
  }, [y]), useEffect(function () {
    var _t$current4;
    (_t$current4 = t.current) === null || _t$current4 === void 0 || _t$current4.setMode(g !== null && g !== void 0 ? g : "forward");
  }, [g]), useEffect(function () {
    var _t$current5;
    (_t$current5 = t.current) === null || _t$current5 === void 0 || _t$current5.setLoop(d !== null && d !== void 0 ? d : !1);
  }, [d]), useEffect(function () {
    var _t$current6;
    (_t$current6 = t.current) === null || _t$current6 === void 0 || _t$current6.setUseFrameInterpolation(R !== null && R !== void 0 ? R : !0);
  }, [R]), useEffect(function () {
    var _t$current7;
    typeof (s === null || s === void 0 ? void 0 : s[0]) == "number" && typeof s[1] == "number" && ((_t$current7 = t.current) === null || _t$current7 === void 0 ? void 0 : _t$current7.setSegment(s[0], s[1]));
  }, [s]), useEffect(function () {
    var _t$current8;
    (_t$current8 = t.current) === null || _t$current8 === void 0 || _t$current8.setBackgroundColor(D !== null && D !== void 0 ? D : "");
  }, [D]), useEffect(function () {
    var _t$current9;
    (_t$current9 = t.current) === null || _t$current9 === void 0 || _t$current9.setRenderConfig(k !== null && k !== void 0 ? k : {});
  }, [JSON.stringify(k)]), useEffect(function () {
    var _t$current0;
    typeof c != "string" && typeof c != "object" || ((_t$current0 = t.current) === null || _t$current0 === void 0 ? void 0 : _t$current0.load(_objectSpread({
      data: c
    }, u.current)));
  }, [c]), useEffect(function () {
    var _t$current1;
    typeof a == "string" && ((_t$current1 = t.current) === null || _t$current1 === void 0 ? void 0 : _t$current1.load(_objectSpread({
      src: a
    }, u.current)));
  }, [a]), useEffect(function () {
    var _t$current10, _v$marker;
    (_t$current10 = t.current) === null || _t$current10 === void 0 || _t$current10.setMarker((_v$marker = v.marker) !== null && _v$marker !== void 0 ? _v$marker : "");
  }, [v.marker]), useEffect(function () {
    var _t$current11;
    (_t$current11 = t.current) === null || _t$current11 === void 0 || _t$current11.loadAnimation(o !== null && o !== void 0 ? o : "");
  }, [o]), useEffect(function () {
    var _t$current12;
    typeof l == "string" && ((_t$current12 = t.current) === null || _t$current12 === void 0 ? void 0 : _t$current12.setTheme(l));
  }, [l]), useEffect(function () {
    var _t$current13;
    (_t$current13 = t.current) === null || _t$current13 === void 0 || _t$current13.setThemeData(P !== null && P !== void 0 ? P : "");
  }, [P]), useEffect(function () {
    var _t$current14, _n$align, _n$fit;
    (_t$current14 = t.current) === null || _t$current14 === void 0 || _t$current14.setLayout({
      align: (_n$align = n === null || n === void 0 ? void 0 : n.align) !== null && _n$align !== void 0 ? _n$align : [.5, .5],
      fit: (_n$fit = n === null || n === void 0 ? void 0 : n.fit) !== null && _n$fit !== void 0 ? _n$fit : "contain"
    });
  }, [n === null || n === void 0 ? void 0 : n.align[0], n === null || n === void 0 ? void 0 : n.align[1], n === null || n === void 0 ? void 0 : n.fit]), jsx("div", _objectSpread(_objectSpread({
    className: W
  }, !W && {
    style: _objectSpread({
      width: "100%",
      height: "100%",
      lineHeight: 0
    }, h)
  }), {}, {
    children: jsx("canvas", _objectSpread({
      ref: J,
      style: {
        width: "100%",
        height: "100%"
      }
    }, v))
  }));
};
var U = function U(o) {
    return new DotLottie(o);
  },
  _ = function _(o) {
    return jsx(m, _objectSpread(_objectSpread({}, o), {}, {
      createDotLottie: U
    }));
  };
var N = function N(o) {
    return new DotLottieWorker(o);
  },
  et = function et(o) {
    return jsx(m, _objectSpread(_objectSpread({}, o), {}, {
      createDotLottie: N
    }));
  };
var nt = function nt(o) {
  DotLottieWorker.setWasmUrl(o), DotLottie.setWasmUrl(o);
};
export { _ as DotLottieReact, et as DotLottieWorkerReact, nt as setWasmUrl };